module.exports = __webpack_public_path__ + "static/img/app.86a5492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app.png
// module id = aTzD
// module chunks = 1